import React from 'react';
import { FormGroup } from 'react-bootstrap';
import CommonAction from './CommonAction';

export function Radio({
  label,
  options,
  error,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  supplierVisible,
  handleSupplierPermission,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  return (
    <FormGroup className="flex-fill position-relative">
      <div>
        <p className={`asterisk-req mb-1 fs-custom-module  ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
        <div className="align-items-center">
          {options?.map((opt, opIndex) => {
            return (
              <div className="custom-radio" key={`${opt?.uniqueKey}`}>
                <input
                  type="radio"
                  id={`${opt?.name}_${opIndex}_${gridIndex}_${pageIndex}`}
                  key={`${label}_${opt}`}
                  name={`radios_${gridIndex}_${pageIndex}`}
                  value={opt?.name}
                  checked={opt?.value}
                  disabled={disable}
                  onChange={(e) => onChange(e.target.checked, opt?.name, gridIndex, pageIndex)}
                />
                <label className="m-0" htmlFor={`${opt?.name}_${opIndex}_${gridIndex}_${pageIndex}`}>
                  {opt?.label || opt?.name}
                </label>
              </div>
            );
          })}
          {fromForm && onElement && (
            <CommonAction
              editingInput={editingInput}
              gridIndex={gridIndex}
              pageIndex={pageIndex}
              showDelete={showDelete}
              deleteItem={deleteItem}
              handleDuplicateItem={handleDuplicateItem}
              supplierVisible={supplierVisible}
              handleSupplierPermission={handleSupplierPermission}
              handleStaticGrid={handleStaticGrid}
              isStatic={isStatic}
            />
          )}
          {error?.status && <span className="error-message">{error.errorMsg}</span>}
        </div>
      </div>
    </FormGroup>
  );
}
export default Radio;
